import { Link } from 'react-router-dom';
import { membershipPlans } from '@/mocks/home';

export default function MembershipSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            会员权益
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            选择适合您的会员方案，享受更多专属权益
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {membershipPlans.map((plan) => {
            const isPrimary = plan.color === 'primary';
            const isAccent = plan.color === 'accent';

            return (
              <div
                key={plan.name}
                className={`relative rounded-lg p-6 border transition-all duration-300 ${
                  plan.highlighted
                    ? 'bg-primary-500 border-primary-500 scale-105 md:scale-110 z-10'
                    : 'bg-background-50 border-background-200/70 hover:border-primary-200'
                }`}
              >
                {plan.highlighted && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    最受欢迎
                  </div>
                )}
                <h3
                  className={`text-lg font-heading font-bold mb-1 ${
                    plan.highlighted ? 'text-background-50' : 'text-foreground-900'
                  }`}
                >
                  {plan.name}
                </h3>
                <div className="flex items-baseline gap-1 mb-5">
                  <span
                    className={`text-3xl font-heading font-bold ${
                      plan.highlighted ? 'text-background-50' : 'text-foreground-950'
                    }`}
                  >
                    ¥{plan.price}
                  </span>
                  <span
                    className={`text-sm ${
                      plan.highlighted ? 'text-background-50/70' : 'text-foreground-400'
                    }`}
                  >
                    {plan.period}
                  </span>
                </div>
                <ul className="flex flex-col gap-2.5 mb-6">
                  {plan.features.map((feature, idx) => (
                    <li
                      key={idx}
                      className={`flex items-start gap-2 text-sm ${
                        plan.highlighted ? 'text-background-50/90' : 'text-foreground-600'
                      }`}
                    >
                      <i
                        className={`ri-check-line mt-0.5 shrink-0 ${
                          plan.highlighted ? 'text-background-50' : 'text-primary-500'
                        }`}
                      ></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/about"
                  className={`block text-center py-2.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                    plan.highlighted
                      ? 'bg-background-50 text-primary-600 hover:bg-background-100'
                      : isAccent
                        ? 'bg-accent-500 text-background-50 hover:bg-accent-600'
                        : 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  }`}
                >
                  {plan.cta}
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}